import { Link } from "react-router-dom";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import { CommonFormPropsType } from "../../../../Type/OtherPages/OtherPages";

const CommonLogo = ({ alignLogo }: CommonFormPropsType) => {
  return (
    <Link className={`logo ${alignLogo ? alignLogo : ""}`} to={`${process.env.PUBLIC_URL}/dashboard/ecommerce`}>
      <Image className='img-fluid for-light' src={dynamicImage("logo/logo-1.png")} alt='loginpage' />
      <Image className='img-fluid for-dark' src={dynamicImage("logo/logo-dark.png")} alt='loginpage' />
    </Link>
  );
};

export default CommonLogo;
